import { Col, Row, Input, Space, Select, Button, Pagination, Form, Table } from 'antd'
import React, { useState, useEffect, useContext } from 'react'

import styled from 'styled-components'
import { getCookie, removeCookie, setCookie } from 'helper/cookie'
const { Option } = Select
import 'styleLess/signature/editprofesskill.scss'
import { SearchOutlined, EditOutlined, RedoOutlined } from '@ant-design/icons'
import { Helmet } from 'react-helmet'
import {
  getResultMember,
  getResultCompany,
  getCallbackskillUser,
  getSKillUser,
} from '../../api/ProfessionSkills/professionskills'
import { getPermissionControl } from 'api/Admin/rolePermission'
import Modaleditprofessionskill from './EditProfessionSkills/editprofessionskills'
import loadingSvg from 'icons/robot1.svg'
import loadingAnimationSvg from 'icons/three-dots.svg'
import emptyicon from 'icons/createproject/Subtask.svg'
const Container = styled.div`
  .colorshowcompanyname {
    color: '#7C7C84';
  }
`

const initalState = {
  data: [],
  isLoading: true,

  pagination: {
    pageSize: 10, //จำนวนข้อมูลในหน้านั้น
    total: 0, //ข้อมูลทั้งหมด
    current: 1,

    showSizeChanger: false,
  },
}

import { CounterContext } from 'redux/Golbalvalues'
import { useHistory } from 'react-router-dom'
import lang from 'lang/en'
import { getFileSecurityFromApi } from 'api/OpenFile'

const professionskills = () => {
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const token = getCookie('access_token_admin')
  const companyIDUser = getCookie('ProfessSK_comID')
  const dataCookieFilter = getCookie('professional_skills_filter')
  const dataCookieToJson = eval('(' + dataCookieFilter + ')')
  const [dataMember, setDataMember] = useState(initalState.data)
  const [dataCompany, setDataCompany] = useState(initalState.data)
  const [pagination, setPagination] = useState(initalState.pagination)
  const [searchCompany, setSearchCompany] = useState(companyIDUser)
  const [searchName, setSearchName] = useState('')
  const [totalPage, setTotalPage] = useState('')
  const [skillListData, setskillListData] = useState([])
  const [form] = Form.useForm()
  const { adminPermission, mainRoleUser, setPathActive } = useContext(CounterContext)
  const [permissionPage, setPermissionPage] = useState({
    create: false,
    read: false,
    update: false,
    delete: false,
  })

  const language = getCookie('lang')
  const word = lang[language]
  const roleUser = getCookie('roleUser')
  const history = useHistory()

  const getPermission = async () => {
    let checkRead = false
    await getPermissionControl({
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (roleUser == 1) {
          checkRead = true
        }
        if (error) {
          return true
        }
        if (status === 200) {
          data.result?.permission?.map((item) => {
            if (item.menu_id == 8) {
              checkRead = true
            }
          })
          checkRead ? _ : history.push(`/no-permission`)
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }
  const fetchListSkillAllIproject = async () => {
    await getSKillUser({
      token: token,
    })
      .then((response) => {
        const { data } = response
        setskillListData(data)
      })
      .catch((err) => err)
  }
  useEffect(() => {
    if (token) {
      setPathActive('/professional-skills')
      getPermission()
      fetchListSkillAllIproject()
    }
  }, [token])

  useEffect(() => {
    if (roleUser == 1) {
      setPermissionPage((prevState) => ({
        ...prevState,
        create: true,
        read: true,
        update: true,
        delete: true,
      }))
    } else {
      let checkread = false
      adminPermission?.map((item) => {
        if (item.menu_id == 8) {
          checkread = true
          setPermissionPage((prevState) => ({
            ...prevState,
            create: item.create == 'Y' ? true : false,
            read: item.read == 'Y' ? true : false,
            update: item.update == 'Y' ? true : false,
            delete: item.delete == 'Y' ? true : false,
          }))
        }
      })
    }
  }, [adminPermission])

  // company

  const onChange = async (e) => {
    if (e.current == undefined) {
      setPagination((prevState) => {
        return {
          ...prevState,
          current: e,
        }
      })
    } else {
      setPagination((prevState) => {
        return {
          ...prevState,
          current: e.current,
        }
      })
    }

    const dataArray = {
      search: `${searchName}`,
      company_id: `${searchCompany}`,
    }
    let pageVals = 0
    if (e.current == undefined) {
      pageVals = e
    } else {
      pageVals = e.current
    }

    try {
      await getResultMember({
        page: pageVals,
        limit: pagination.pageSize,
        params: dataArray,
        token: token,
        isSkill: 'y',
      }).then((response) => {
        const { status, data, error } = response
        if (error) {
          setDataMember([])
          setIsLoading(false)
          return true
        }
        if (status === 200) {
          window.scrollTo(0, 0)
          setTotalPage(data.total_page)

          setPagination((prevState) => {
            return {
              ...prevState,
              current: pageVals,
              total: data.total_record,
            }
          })
          setDataMember(data.data)
          setIsLoading(false)
        } else {
          setDataMember([])
          setIsLoading(false)
          return true
        }
      })
    } catch (error) {
      setDataMember([])
      setIsLoading(false)
      console.log(error)
    }
  }

  const onFinish = async (values) => {
    if (values.name == undefined) {
      values.name = ''
    }
    if (values.company == undefined) {
      values.company = ''
    }

    setSearchCompany(values.company)
    setSearchName(values.name)

    const dataArray = {
      search: `${values.name}`,
      company_id: `${values.company}`,
    }
    const dataToCookie = {
      search: `${values.name}`,
      company_id: values.company,
    }

    const expirationDate = new Date()
    expirationDate.setFullYear(expirationDate.getFullYear() + 1)
    setCookie('professional_skills_filter', dataToCookie, { expires: expirationDate })

    setIsLoading(true)
    try {
      await getResultMember({
        page: 1,
        limit: pagination.pageSize,
        params: dataArray,
        token: token,
        isSkill: 'y',
      }).then((response) => {
        const { status, data, error } = response
        if (error) {
          setDataMember([])
          setIsLoading(false)
          setPagination((prevState) => {
            return {
              ...prevState,

              total: 0,
            }
          })
          return true
        }
        if (status === 200) {
          setTotalPage(data.total_page)
          setDataMember(data.data)
          setIsLoading(false)
          setPagination((prevState) => {
            return {
              ...prevState,
              current: 1,
              total: data.total_record,
            }
          })
        } else {
          setDataMember([])
          setIsLoading(false)
          setPagination((prevState) => {
            return {
              ...prevState,

              total: 0,
            }
          })
          return true
        }
      })
    } catch (error) {
      setDataMember([])
      setIsLoading(false)
      console.log(error)
    }
  }
  const getDataMember = async () => {
    const dataArray = {
      search: dataCookieFilter
        ? `${dataCookieToJson.search === undefined ? '' : dataCookieToJson.search}`
        : '',
      company_id: dataCookieFilter
        ? `${dataCookieToJson.company_id}`
        : `${searchCompany}`,
    }
    try {
      await getResultMember({
        page: pagination.current,
        limit: pagination.pageSize,
        params: dataArray,
        token: token,
        isSkill: 'y',
      }).then((response) => {
        const { status, data, error } = response
        if (error) {
          setDataMember([])
          setIsLoading(false)
          return true
        }
        if (status === 200) {
          setTotalPage(data.total_page)
          setPagination((prevState) => {
            return {
              ...prevState,
              total: data.total_record,
            }
          })
          setDataMember(data.data)
          setIsLoading(false)
        } else {
          setDataMember([])
          setIsLoading(false)
          return true
        }
      })
    } catch (error) {
      setDataMember([])
      setIsLoading(false)
      console.log(error)
    }
  }
  const getDataCompany = async () => {
    await getResultCompany({
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          setDataCompany([])
          return true
        }
        if (status === 200) {
          setDataCompany(data)

          form.setFieldsValue({
            company: dataCookieFilter
              ? dataCookieToJson.company_id
              : parseInt(companyIDUser),
            name: dataCookieFilter ? dataCookieToJson.search : '',
          })
        } else {
          setDataCompany([])
          return true
        }
      })
      .catch((error) => {
        setDataCompany([])
        console.error(error)
      })
  }

  useEffect(() => {
    if (token) {
      getDataMember()
      getDataCompany()
      if (dataCookieFilter) {
        setSearchCompany(dataCookieToJson.company_id)
        setSearchName(dataCookieToJson.search)
      }
    }
  }, [token])

  const [ModalVision, setModalVision] = useState(false)
  const [memberData, setMemberData] = useState()
  const [comIduser, setcomIduser] = useState()
  const clickedit = (record, iduser) => {
    setModalVision(true)
    setMemberData(record)
    setcomIduser(iduser)
  }

  const onOk = (skilllist, id) => {
    let ListID = []
    for (var i = 0; i < skilllist.length; i++) {
      ListID.push(skilllist[i].id)
    }

    const dataArray = {
      account_id: parseInt(id),
      professional_skill: `${ListID}`,
    }

    try {
      getCallbackskillUser({
        params: dataArray,
        token: token,
      }).then((res) => { })
    } catch (error) {
      console.log(error)
    }
    setModalVision(false)
  }

  const [dataList, setDataList] = useState([])

  useEffect(() => {
    const fetchData = async () => {
      const results = await Promise.all(
        dataMember?.map(async (item) => {
          if (!item?.pic_display.includes('cpfit')) {
            const response = await getFileSecurityFromApi({
              url: item?.pic_display,
              token,
            })
            const { data } = response
            const blobUrl = URL.createObjectURL(data)
            return { ...item, pic_display: blobUrl } // หรือจะเลือกใช้ property ที่คุณต้องการจาก API ก็ได้
          } else {
            return { ...item, pic_display: item.pic_display } // หรือจะเลือกใช้ property ที่คุณต้องการจาก API ก็ได้
          }
        }),
      )
      setDataList(results)
    }

    fetchData()
  }, [dataMember])

  const dataSource = dataList?.map((item) => ({
    key: item.id,
    fullname: item.firstname + ' ' + item.lastname,
    email: item.email,
    position: item.skill_name,
    company: item.companyname_en,
    companyIduser: item.company_id,
    pic_display: item.pic_display,
  }))

  const columns = [
    {
      title: word['Full_name'],
      dataIndex: 'fullname',
      width: 280,
      render: (text, record) => (
        <Space size="middle">
          <img className="imageStyle" src={record.pic_display}></img>
          <p>{text}</p>
        </Space>
      ),
      ellipsis: true,
    },
    {
      title: word['Email'],
      dataIndex: 'email',
      width: 280,
      ellipsis: true,
    },
    {
      title: word['Skills'],
      dataIndex: 'position',
      width: 280,
      ellipsis: true,
    },
    {
      title: 'Business',
      dataIndex: 'company',
      width: 280,
      ellipsis: true,
    },
    {
      title: '',
      render: (text, record) => (
        <Space size="middle">
          <a hidden={permissionPage.update ? false : true}>
            <EditOutlined onClick={() => clickedit(record.key, record.companyIduser)} />
          </a>
        </Space>
      ),
    },
  ]

  const firstLoadingData = (total) => {
    if (isLoading === true) {
      return (
        <div className={isLoading ? 'waite profesionalstyle-style ' : 'active-waite'}>
          <img className="robot" src={loadingSvg}></img>
          <img src={loadingAnimationSvg}></img>
        </div>
      )
    } else if (isLoading === false) {
      if (total == 0) {
        return (
          <div className="emyty-state-professional-skill">
            <img className="icons" src={emptyicon}></img>
            <h2 className="font-style">{word['No_Data_Member']}</h2>
          </div>
        )
      } else {
        if (totalPage == 1) {
          return (
            <div style={{ minHeight: '56vh' }}>
              <Row
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }}
              >
                {showCompany(searchCompany)}
                <h4 style={{ marginLeft: 12, color: '#7C7C84' }}>
                  {showNumResult(pagination.total)}
                </h4>
                {showName(searchName)}
              </Row>
              <Table
                className="tableassignee"
                style={{ marginTop: 16 }}
                dataSource={dataSource}
                columns={columns}
                pagination={false}
                onChange={onChange}
              />
            </div>
          )
        } else {
          return (
            <div style={{ minHeight: '56vh' }}>
              <Row
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }}
              >
                {showCompany(searchCompany)}
                <h4 style={{ marginLeft: 12, color: '#7C7C84' }}>
                  {showNumResult(pagination.total)}
                </h4>
                {showName(searchName)}
              </Row>
              <Table
                className="tableassignee"
                style={{ marginTop: 16 }}
                dataSource={dataSource}
                columns={columns}
                pagination={pagination}
                onChange={onChange}
              />
            </div>
          )
        }
      }
    }
  }

  const showCompany = (company) => {
    if (dataCompany == '') {
    } else {
      dataCompany.map((item) => {
        if (company == item.id) {
          company = item.name_en
        }
      })
      return <h3>{company}</h3>
    }
  }
  const showName = (name) => {
    if (name !== '') {
      return (
        <Row style={{ marginTop: '8px' }}>
          <h4 style={{ marginLeft: 6, color: '#7C7C84' }}>{word['of']} </h4>
          <h4 style={{ marginLeft: 6, color: '#7C7C84' }}>"{name}"</h4>
        </Row>
      )
    }
  }

  const showNumResult = (result) => {
    if (result != 0) {
      return (
        <h4 style={{ marginLeft: 12, color: '#7C7C84' }}>
          {result} {word['results']}
        </h4>
      )
    } else {
      return (
        <h4 style={{ marginLeft: 12, color: '#7C7C84' }}>
          {pagination.total} {word['results']}
        </h4>
      )
    }
  }
  const checkPagination = (totalPage) => {
    if (totalPage !== 1) {
      return (
        <Pagination
          className="pagination"
          current={pagination.current}
          defaultCurrent={pagination.current}
          total={pagination.total}
          pageSize={pagination.pageSize}
          onChange={onChange}
          showSizeChanger={false}
        />
      )
    }
  }
  const showDataEventResponsive = () => {
    return dataMember.map((item, idx) => {
      return (
        <div key={idx} className="box-member-professional-skill-people">
          <div className="left-peo">
            <img className="imageStyle" src={item.pic_display}></img>
          </div>
          <div className="right-peo">
            <div className="item-peo-1">
              <div className="name-content">
                <span className="small">{word['Full_name']}</span>
                <div style={{ display: 'grid' }}>
                  <p className="cutter-text-line-1 ">
                    {item.firstname}
                    {'  '}
                    {item.lastname}
                  </p>
                </div>
              </div>
              <div className="icon-content">
                <a hidden={permissionPage.update ? false : true}>
                  <EditOutlined
                    className="editoutlined"
                    onClick={() => clickedit(item.id, item.company_id)}
                  />
                </a>
              </div>
            </div>
            <div className="item-peo-2">
              <span className="small">{word['Email']}</span>
              <div style={{ display: 'grid' }}>
                {item.email != '' && item.email != undefined ? (
                  <p className="cutter-text-line-1 ">{item.email}</p>
                ) : (
                  <p className="cutter-text-line-1 ">-</p>
                )}
              </div>
            </div>
            <div className="item-peo-3">
              <span className="small">{word['Skills']}</span>
              <div style={{ display: 'grid' }}>
                {item.skill_name != '' && item.skill_name != undefined ? (
                  <p className="cutter-text-line-1 ">{item.skill_name}</p>
                ) : (
                  <p className="cutter-text-line-1 ">-</p>
                )}
              </div>
            </div>
            <div className="item-peo-4">
              <span className="small">{word['Company']}</span>
              <div style={{ display: 'grid' }}>
                {item.companyname_en != '' && item.companyname_en != undefined ? (
                  <p className="cutter-text-line-1 ">{item.companyname_en}</p>
                ) : (
                  <p className="cutter-text-line-1 ">-</p>
                )}
              </div>
            </div>
          </div>
        </div>
      )
    })
  }
  const resetFilter = () => {
    setSearchCompany(companyIDUser)
    removeCookie('professional_skills_filter')
    form.setFieldsValue({ company: parseInt(companyIDUser), name: '' })
    window.location.reload()
  }
  return (
    <Container className="Main-professionalskill-container">
      <Helmet>
        <title>AXONS PROJECT | Professional skills</title>
      </Helmet>
      <Form form={form} onFinish={onFinish} className="disable-page">
        <h1 className="title-professional-skill no-breadcrumb">
          {word['Professional_skills']}
        </h1>
        <Row className="row-searh-content">
          <div>
            <Form.Item name="name" style={{ marginBottom: 0 }}>
              <Input
                size="large"
                placeholder="Name,Skill"
                allowClear
                suffix={<SearchOutlined style={{ fontSize: 20 }} />}
              ></Input>
            </Form.Item>
          </div>
          <div>
            <Form.Item name="company" style={{ marginBottom: 0 }}>
              <Select
                placeholder="Select Business"
                allowClear
                size="large"
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                disabled={roleUser == 1 ? false : true}
              >
                <Option value="">All Business</Option>
                {dataCompany.map((item) => (
                  <Option value={item.id}>{item.name_en}</Option>
                ))}
              </Select>
            </Form.Item>
          </div>
          <div style={{ height: '48px' }}>
            <Button htmlType="submit" className="BTN_Next" style={{ width: '50%' }}>
              <SearchOutlined className="Icon-color" />
              {word['Search']}
            </Button>
            <Button
              type="primary"
              className="mini-search-btn-admin-reset"
              style={{
                width: '99px',
                height: '40px',
                marginLeft: '8px',
                paddingTop: '7px',
              }}
              onClick={() => resetFilter()}
            >
              <RedoOutlined className="Icon-color" style={{ color: '#294f9f' }} />
              Reset
            </Button>
          </div>
        </Row>

        <Col
          className="area-desktop-professional-skill"
          span={24}
          style={{
            backgroundColor: 'white',
            marginTop: 18,
            padding: 32,
            borderRadius: ' 8px',
          }}
        >
          {firstLoadingData(pagination.total)}
        </Col>
        <div className="content-styles">
          {isLoading === false ? (
            <div className="results">{showNumResult(pagination.total)}</div>
          ) : (
            <></>
          )}
          {isLoading === false ? (
            <div>
              {pagination.total === 0 ? (
                <div className="emyty-state-professional-skill">
                  <img className="icons" src={emptyicon}></img>
                  <h2 className="font-style">{word['No_Data_Member']}</h2>
                </div>
              ) : (
                <div className="area-mobile-professional-skill">
                  {showDataEventResponsive(pagination.total)}
                </div>
              )}
            </div>
          ) : (
            <div
              className={isLoading ? 'waite profesionalstyle-style  ' : 'active-waite'}
            >
              <img className="robot" src={loadingSvg}></img>
              <img src={loadingAnimationSvg}></img>
            </div>
          )}

          {isLoading === false ? (
            <div className="pagination-content-profesionalskill">
              {checkPagination(pagination.total)}
            </div>
          ) : (
            <></>
          )}
        </div>
      </Form>

      <Modaleditprofessionskill
        ModalVision={ModalVision}
        setModalVision={setModalVision}
        memberData={memberData}
        comIduser={comIduser}
        onOk={onOk}
        getDataMember={getDataMember}
        // setskillListData={setskillListData}
        skillListData={skillListData}
        dataMember={dataMember}
      />
    </Container>
  )
}

export default professionskills
